import { Component } from '@angular/core';
import { soundpostPostingGroupLineEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Posting Group Lines') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostpostinggroupline-form',
    templateUrl: './soundpostpostinggroupline.form.component.html'
})
export class soundpostPostingGroupLineFormComponent extends BaseFormComponent {
    public record!: soundpostPostingGroupLineEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'postingGroupLineDimensions', sectionName: 'Posting Group Line Dimensions', isExpanded: false }
        ]);
    }
}

